module.exports = __webpack_public_path__ + "static/media/vertigo.2bddab2b.png";